import React from "react";

const PJLabels = ({ circleProps, windowWidth, radius, pjTextProps }) => {
  return (
    <g className="pj-labels-group">
      <circle
        className="pj-circle"
        {...circleProps}
        cx={windowWidth / 2 - radius}
      />
      <circle
        className="pj-circle"
        {...circleProps}
        cx={windowWidth - (windowWidth / 2 - radius)}
      />
      <text
        className="pj-label-p"
        {...pjTextProps}
        x={windowWidth / 2 - radius}
      >
        P
      </text>
      <text
        className="pj-label-j"
        {...pjTextProps}
        x={windowWidth - (windowWidth / 2 - radius)}
      >
        J
      </text>
    </g>
  );
};

export default PJLabels;
